import { notification } from "antd";
import { NavigateFunction } from "react-router";
import { getEnvironmentService } from "../../backend";
import { trackEnvComponentRemoved } from "../../backend/tracking/environment";
import { DoubleConfirmationModalProps } from "../../contexts/Modal";

interface IDeleteResourceProps {
    envId: string;
    projectId: string;
    openConfirmModal: (props: DoubleConfirmationModalProps) => void;
    navigate: NavigateFunction;
    resourceName: string;
    componentId: string;
    componentName: string;
}

export async function handleDeleteResource({
    envId,
    projectId,
    navigate,
    resourceName,
    componentId,
    componentName
}: Omit<IDeleteResourceProps, "openConfirmModal">) {
    try {
        await getEnvironmentService().deleteResource(envId, resourceName, projectId);
        notification.success({
            message: "Resource deleted",
            description: `The resource ${resourceName} has been successfully deleted from this environment.`
        });
        trackEnvComponentRemoved(
            envId,
            componentId,
            componentName
        );
        setTimeout(() => {
            navigate(`/projects/${projectId}/environments/${envId}/infrastructure`);
        }, 1000);
    } catch (error) {
        notification.error({
            message: "Error deleting resource",
            description: (error as any).response!.data!.message
        });
    }
}